import React, { SetStateAction, Dispatch } from 'react';
import { InputLabel, Select, MenuItem } from '@material-ui/core';
import { useQuery } from '@apollo/client';
import { GET_PRODUCT_TYPES } from '../../../../queries/products/productType';
import useStyles from './styles';

const GetProducts = () => useQuery(GET_PRODUCT_TYPES);

export interface ISelectProductTypesProps {
  productTypeId: string;
  setProductTypeId: Dispatch<SetStateAction<string | null>>;
  labelAll?: boolean;
  className?: string;
}

export const SelectProductTypes: React.FC<ISelectProductTypesProps> = ({
  productTypeId,
  setProductTypeId,
  labelAll,
  className,
}) => {
  const queryProducts = GetProducts();
  const classes = useStyles();

  const handleChange = (
    event: { target: { value: string } },
    setValue: Dispatch<SetStateAction<string | null>>,
  ) => {
    if (event.target.value === 'null') setValue(null);
    else setValue(event.target.value);
  };

  const maplistProductTypes = (productType: { id: string; name: string }) => {
    return (
      <MenuItem key={productType.id} value={productType.id}>
        {productType.name}
      </MenuItem>
    );
  };

  if (queryProducts.loading) return <>Loading...</>;

  if (queryProducts.error) {
    return <>{`Error! ${queryProducts.error.message}`}</>;
  }

  return (
    <>
      <InputLabel className={className || classes.inputLabel}>
        ProductType&nbsp;
      </InputLabel>
      <Select
        fullWidth
        id="productTypeId"
        labelId="select-settings-productTypeId"
        onChange={(e: any) => handleChange(e, setProductTypeId)}
        className={classes.marginDefault}
        value={productTypeId != null ? productTypeId : 'null'}
      >
        {labelAll && (
          <MenuItem key="" value="null" selected>
            All
          </MenuItem>
        )}
        {queryProducts.data && queryProducts.data.listProductTypes
          ? queryProducts.data.listProductTypes.map(maplistProductTypes)
          : null}
      </Select>
    </>
  );
};
